<template>
  <div id="app">
		<keep-alive include='Login'>
			<router-view></router-view>
		</keep-alive>
	</div>
</template>


<script>

export default {
  name: 'app',
  components: {},
	created: function(){
		// 读取会话存储保存Store
		if (sessionStorage.getItem('store')){
			this.$store.replaceState(
				Object.assign(
					{},
					this.$store.state,
					JSON.parse(sessionStorage.getItem('store'))
				)
			)
		}
		// 监听刷新、再次存储Store
		window.addEventListener('beforeunload', () => {
			sessionStorage.setItem('store', JSON.stringify(this.$store.state))
		})
	},
	mounted: function(){
	
	},
}
</script>

<style>

</style>
